module.exports = __webpack_public_path__ + "static/img/9.257dadf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/9.png
// module id = HSx2
// module chunks = 0